module.exports = __webpack_public_path__ + "static/media/puzzle-game.8298572b.webp";